<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="handleDialog" persistent max-width="600px">
        <v-card class="modern-card" dark>
          <div class="card-header">
            <v-icon large color="#d4a72c" class="header-icon"
              >mdi-account-edit</v-icon
            >
            <span class="text-h5 font-weight-medium">Registro Manual</span>
          </div>
          <v-card-text>
            <v-container>
              <v-row>
                <!-- <v-col cols="12" md="6">
                  <v-text-field
                    label="Apellido y Nombre"
                    v-model="nombre"
                    required
                    outlined
                    color="#d4a72c"
                    class="modern-input"
                    prepend-inner-icon="mdi-account"
                  ></v-text-field>
                </v-col> -->
                <v-col cols="12">
                  <v-text-field
                    ref="dniInput"
                    label="DNI"
                    v-model="dni"
                    v-on:keyup.enter="envioForm()"
                    :disabled="loading"
                    :loading="loading"
                    outlined
                    color="#d4a72c"
                    class="modern-input"
                    prepend-inner-icon="mdi-card-account-details"
                    autofocus
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-chip
                    small
                    color="rgba(212, 167, 44, 0.15)"
                    text-color="#e9c45c"
                    class="mb-2"
                  >
                    <v-icon small left>mdi-keyboard</v-icon>
                    Presione F4 para acceder rápidamente
                  </v-chip>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="card-actions">
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              text
              @click="cerrarDialog()"
              :disabled="loading"
              class="action-btn"
            >
              <v-icon left>mdi-close</v-icon> Cancelar
            </v-btn>
            <v-btn
              color="#d4a72c"
              @click="envioForm()"
              :disabled="loading"
              :loading="loading"
              class="action-btn font-weight-bold"
              style="color: #12133f"
              elevation="2"
            >
              <v-icon left v-if="!loading">mdi-content-save</v-icon>
              <span v-if="loading">Guardando...</span>
              <span v-else>Guardar</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "cargaManual",
  props: {
    handleDialog: {
      type: Boolean,
      default: false,
    },
    entrada: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      nombre: "",
      dni: null,
      loading: false,
    };
  },
  watch: {
    handleDialog(newVal) {
      if (newVal) {
        // Usar nextTick para asegurar que el DOM esté actualizado
        this.$nextTick(() => {
          if (this.$refs.dniInput) {
            this.$refs.dniInput.focus();
          }
        });
      }
    },
  },
  methods: {
    cerrarDialog() {
      this.$emit("cerrarForm", false);
    },
    async envioForm() {
      // Prevenir múltiples envíos
      if (this.loading) {
        return;
      }

      this.loading = true;

      try {
        let datosPersonales = {
          nombre: this.nombre,
          dni: this.dni,
        };
        datosPersonales.entrada = this.entrada ? 1 : 0;

        await axios
          .post(process.env.VUE_APP_BACKEND_ENVIRONMENT + "validar/acreditar", {
            ...datosPersonales,
          })
          .then((res) => {
            this.respuesta = res.data;
            console.log(this.respuesta);
            this.respuesta.tiempo = 4000;
            this.$emit("handleDialogRespuesta", this.respuesta);
          })
          .catch((e) => {
            console.log(e);
            e.tiempo = 8000;
            this.$emit("handleDialogRespuesta", e);
          });

        console.log(this.nombre, this.dni);
      } finally {
        this.loading = false;
        this.dni = "";
        this.$emit("cerrarForm", false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modern-card {
  border-radius: 12px;
  background-color: rgba(18, 19, 63, 0.97) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(212, 167, 44, 0.4);
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  padding: 20px 24px;
  background-color: rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);

  .header-icon {
    margin-right: 12px;
    background-color: rgba(212, 167, 44, 0.15);
    padding: 8px;
    border-radius: 50%;
  }
}

.modern-input {
  margin-bottom: 10px;
}

.card-actions {
  padding: 16px 24px;
  background-color: rgba(0, 0, 0, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.action-btn {
  text-transform: none;
  font-weight: 500;
  padding: 0 20px;
  height: 36px;
  margin-left: 10px;
  letter-spacing: 0.5px;
}
</style>
